import { createFormContext } from "@mantine/form";
import { GeoFilter } from "shared/components/organization/geolocations/types";
import { geozod } from "shared/utils/zod";
import { z } from "zod";

const GeoFilterSchema: z.ZodType<GeoFilter> = z.object({
    id: z.string(),
    name: z.string(),
    boundary: z.string(),
});

export const GeoLocationsFormSchema = z.object({
    drawingLayerId: z.string().nullable(),
    drawingLayerLocked: z.boolean(),
    polygon: geozod.polygon().nullable(),
    editingShape: GeoFilterSchema.nullable(),
    activeLayerId: z.string().nullable(),
    hiddenLayerIds: z.record(z.boolean()),
    hoveredShapeId: z.string().nullable(),
});

type GeoLocationsFormState = z.infer<typeof GeoLocationsFormSchema>;

export const createGeoLocationsFormState = (): GeoLocationsFormState => ({
    drawingLayerId: null,
    drawingLayerLocked: false,
    polygon: null,
    editingShape: null,
    activeLayerId: null,
    hiddenLayerIds: {},
    hoveredShapeId: null,
});

export const [GeoLocationsFormProvider, useGeoLocationsFormContext] = createFormContext<GeoLocationsFormState>();
